import { $apiDelete, $apiGet, $apiPost, $apiPut } from '~/utils/request'
import type { SysEnterprise } from '~/models'

export const GetAll = () => $apiGet<SysEnterprise[]>(`/v1/sysEnterprise/all`)
